import { Account, Transaction } from '../App';

export const demoAccounts: Account[] = [
  { id: 'acc_demo_1', name: 'Everyday', balance: 1250.75, type: 'TRANSACTIONAL', owner: 'INDIVIDUAL' },
  { id: 'acc_demo_2', name: 'Savings', balance: 4200.00, type: 'SAVER', owner: 'INDIVIDUAL' },
  { id: 'acc_demo_3', name: '2Up Spending', balance: 0.00, type: 'SAVER', owner: 'INDIVIDUAL' },
  { id: 'acc_demo_4', name: 'Essentials', balance: 716.02, type: 'SAVER', owner: 'INDIVIDUAL' },
  { id: 'acc_demo_5', name: 'Holiday Fund', balance: 850.00, type: 'SAVER', owner: 'INDIVIDUAL' },
  { id: 'acc_demo_6', name: 'New Laptop', balance: 150.00, type: 'MAYBUY_SAVER', owner: 'INDIVIDUAL' },
];

export const demoTransactions: Transaction[] = [
  // Recent transactions (last few days)
  {
    id: 'txn_demo_1',
    description: 'Coffee - Local Cafe',
    amount: 4.50,
    type: '',
    status: 'SETTLED',
    date: '2025-01-15',
    time: '8:15am',
    text: 'LOCAL CAFE',
    message: 'Morning coffee',
    roundup: 'false',
    tags: ['coffee', 'food'],
    merchantLogoUrl: 'https://logo.clearbit.com/starbucks.com',
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_2',
    description: 'Groceries - Supermarket',
    amount: 67.80,
    type: '',
    status: 'SETTLED',
    date: '2025-01-15',
    time: '6:30pm',
    text: 'SUPERMARKET CHAIN',
    message: 'Weekly groceries',
    roundup: 'true',
    tags: ['groceries'],
    merchantLogoUrl: 'https://logo.clearbit.com/woolworths.com.au',
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_3',
    description: 'Transfer to Savings',
    amount: 500.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-14',
    time: '9:00am',
    text: 'TRANSFER TO SAVINGS',
    message: 'Monthly savings',
    roundup: 'false',
    tags: ['transfer'],
    accountId: 'acc_demo_2',
    accountName: 'Savings'
  },
  {
    id: 'txn_demo_4',
    description: 'Salary - Tech Company',
    amount: 4500.00,
    type: '+',
    status: 'SETTLED',
    date: '2025-01-14',
    time: '9:00am',
    text: 'TECH COMPANY PAYROLL',
    message: 'Monthly salary',
    roundup: 'false',
    tags: ['income'],
    merchantLogoUrl: 'https://logo.clearbit.com/atlassian.com',
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_5',
    description: '2Up Transfer',
    amount: 2.50,
    type: '',
    status: 'SETTLED',
    date: '2025-01-13',
    time: '2:15pm',
    text: '2UP TRANSFER',
    message: 'Round up savings',
    roundup: 'false',
    tags: ['2up'],
    accountId: 'acc_demo_3',
    accountName: '2Up Spending'
  },
  {
    id: 'txn_demo_6',
    description: 'Lunch - Food Court',
    amount: 12.80,
    type: '',
    status: 'SETTLED',
    date: '2025-01-13',
    time: '12:30pm',
    text: 'FOOD COURT VENDOR',
    message: 'Lunch break',
    roundup: 'true',
    tags: ['food'],
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_7',
    description: 'Transfer to Essentials',
    amount: 200.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-12',
    time: '10:00am',
    text: 'TRANSFER TO ESSENTIALS',
    message: 'Bills and essentials',
    roundup: 'false',
    tags: ['transfer'],
    accountId: 'acc_demo_4',
    accountName: 'Essentials'
  },
  {
    id: 'txn_demo_8',
    description: 'Electricity Bill',
    amount: 85.60,
    type: '',
    status: 'SETTLED',
    date: '2025-01-12',
    time: '8:00am',
    text: 'ELECTRICITY PROVIDER',
    message: 'Monthly bill',
    roundup: 'false',
    tags: ['bills'],
    merchantLogoUrl: 'https://logo.clearbit.com/agl.com.au',
    accountId: 'acc_demo_4',
    accountName: 'Essentials'
  },
  {
    id: 'txn_demo_9',
    description: 'Transfer to Holiday Fund',
    amount: 100.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-11',
    time: '7:00pm',
    text: 'TRANSFER TO HOLIDAY',
    message: 'Holiday savings',
    roundup: 'false',
    tags: ['transfer'],
    accountId: 'acc_demo_5',
    accountName: 'Holiday Fund'
  },
  {
    id: 'txn_demo_10',
    description: 'Transfer to New Laptop',
    amount: 50.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-10',
    time: '6:00pm',
    text: 'TRANSFER TO LAPTOP',
    message: 'Laptop savings',
    roundup: 'false',
    tags: ['transfer'],
    accountId: 'acc_demo_6',
    accountName: 'New Laptop'
  },
  // Older transactions for variety
  {
    id: 'txn_demo_11',
    description: 'Petrol - Shell',
    amount: 45.20,
    type: '',
    status: 'SETTLED',
    date: '2025-01-09',
    time: '5:45pm',
    text: 'SHELL STATION',
    message: 'Fuel up',
    roundup: 'true',
    tags: ['transport'],
    merchantLogoUrl: 'https://logo.clearbit.com/shell.com',
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_12',
    description: 'Netflix Subscription',
    amount: 15.99,
    type: '',
    status: 'SETTLED',
    date: '2025-01-08',
    time: '12:00am',
    text: 'NETFLIX',
    message: 'Monthly subscription',
    roundup: 'false',
    tags: ['entertainment'],
    merchantLogoUrl: 'https://logo.clearbit.com/netflix.com',
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_13',
    description: 'Dinner - Restaurant',
    amount: 68.50,
    type: '',
    status: 'SETTLED',
    date: '2025-01-07',
    time: '8:30pm',
    text: 'RESTAURANT NAME',
    message: 'Date night',
    roundup: 'true',
    tags: ['dining'],
    accountId: 'acc_demo_1',
    accountName: 'Everyday'
  },
  {
    id: 'txn_demo_14',
    description: 'Transfer to 2Up Spending',
    amount: 15.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-06',
    time: '9:00am',
    text: 'TRANSFER TO 2UP',
    message: 'Weekly 2Up transfer',
    roundup: 'false',
    tags: ['transfer'],
    accountId: 'acc_demo_3',
    accountName: '2Up Spending'
  },
  {
    id: 'txn_demo_15',
    description: 'Phone Bill',
    amount: 45.00,
    type: '',
    status: 'SETTLED',
    date: '2025-01-05',
    time: '10:00am',
    text: 'TELCO PROVIDER',
    message: 'Monthly phone bill',
    roundup: 'false',
    tags: ['bills'],
    merchantLogoUrl: 'https://logo.clearbit.com/telstra.com.au',
    accountId: 'acc_demo_4',
    accountName: 'Essentials'
  }
];


